import { useTranslation } from "next-i18next";
import { useContext } from "react";

import { Header } from "@baseComponents/Header";
import { CTA } from "@components/CTA";
import { BlogContext } from "@context/BlogContext";
import { portfolioArticleCards } from "@portfolios";

import { ProjectsLayout } from "./ProjectsLayout";
import {
  StyledArticlesMainLayout,
  StyledArticlesSeeAlso,
} from "./styles.styled";

export default function MDXPageEN() {
  const blogContext = useContext(BlogContext);
  const { t } = useTranslation();

  return (
    <ProjectsLayout
      title="Our work: from idea to solution"
      description="Discover how we transform ideas into functional digital products. From concept to launch, our projects showcase thoughtful design, clean code, and real business impact. Take a look at what we've built together with our clients."
    >
      <Header
        header="Case study"
        subheader="From concept to completion, see how we turn ideas into solutions for our clients."
      />

      <StyledArticlesMainLayout
        articles={portfolioArticleCards.map(({ en }) => en)}
      />

      <StyledArticlesSeeAlso
        articles={blogContext.getSortedArticleCards()}
        sectionHeader={t("projects_page.see_also_header")}
        sectionSubheader={t("projects_page.see_also_subheader")}
      />

      <CTA
        buttonText="Get a Free Consultation"
        header="Let’s talk about your project."
        subheader="Get a free consultation and see how we can bring your ideas to life."
      />
    </ProjectsLayout>
  );
}
